import { render, staticRenderFns } from "./ProlongRulesRadio.vue?vue&type=template&id=efbce32a"
import script from "./ProlongRulesRadio.vue?vue&type=script&lang=js"
export * from "./ProlongRulesRadio.vue?vue&type=script&lang=js"
import style0 from "./ProlongRulesRadio.vue?vue&type=style&index=0&id=efbce32a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports